import React from "react";
import { Link } from "react-router-dom";
import { PrinterFill } from "react-bootstrap-icons";

const PrintInvoiceBtn = ({ url }) => (
    <Link
        to={url}
        // target="_blank"
        rel="noopener noreferrer"
        className="btn btn-info btn-sm"
        title="Print Invoice"
    >
        <PrinterFill size={16} color="#fff" />
    </Link>
);

export default PrintInvoiceBtn;